import { Button } from "@novaescola/eva-react-v2/lib/Button";
import { Typography } from "@novaescola/eva-react-v2/lib/Typography";
import Cookies from "js-cookie";
import * as React from "react";
import { useEffect, useState } from "react";
import { AccountApi } from "../../api/account/account.api";

const AntiracistManifesto = () => {
  const [token, setToken] = useState(null);
  const [signedManifesto, setSignedManifesto] = useState(false);

  const handleButton = async () => {
    try {
      if (token) {
        await AccountApi.signAntiRacistManifesto(token);

        setSignedManifesto(true);
      } else {
        Cookies.set("ane_redirect", window.location.href, {
          domain: ".novaescola.org.br",
        });
        window.location.href = "https://account.novaescola.org.br/auth/signin";
      }
    } catch (_) {
      return;
    }
  };

  useEffect(() => {
    setToken(Cookies.get("Bearer"));
  }, []);

  useEffect(() => {
    async function getAntiRacistManifestoInfo() {
      try {
        if (token) {
          const data = await AccountApi.getAntiRacistManifesto(token);

          setSignedManifesto(data.signManifesto ? data.signManifesto : false);
        }
      } catch (_) {
        return;
      }
    }

    getAntiRacistManifestoInfo();
  }, [token]);

  return (
    <div className="eva-card eva-card-borderless eva-bg-inst-100">
      <div className="eva-card-info">
        {signedManifesto ? (
          <div className="d-flex">
            <i className="fa-regular fa-circle-check eva-mr-05" />
            <Typography variant="subtitle" size={2} className="eva-text-center">
              Você assinou o manifesto. Obrigado por fazer parte do Movimento!
            </Typography>
          </div>
        ) : (
          <div className="d-grid ji-center">
            <Typography
              variant="title"
              size={5}
              className="eva-text-center eva-mb-07"
            >
              Assine o manifesto e apoie a causa.
            </Typography>
            <Button color="white" style={{borderColor: '#000'}} size="medium" onClick={handleButton}>
              Assinar manifesto
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AntiracistManifesto;
